// extracted by mini-css-extract-plugin
module.exports = {"table":"movements-table-component_table_39Yzn"};